export function buildAgreementsRowsModel(dtoRows) {
  return dtoRows.map((item, index) => ({
    id: item.id || `agreement-${index}-${Date.now()}`,
    name: item.name || '',
    isEditing: false,
    draftName: item.name || '',
  }));
}

export function buildNewAgreementRow(name) {
  const value = String(name || '').trim();
  return {
    id: `agreement-new-${Date.now()}`,
    name: value,
    isEditing: false,
    draftName: value,
  };
}

export function reorderAgreementRows(rows, sourceId, targetId) {
  const sourceIndex = rows.findIndex((row) => row.id === sourceId);
  const targetIndex = rows.findIndex((row) => row.id === targetId);

  if (sourceIndex < 0 || targetIndex < 0 || sourceIndex === targetIndex) {
    return rows;
  }

  const nextRows = [...rows];
  const [moved] = nextRows.splice(sourceIndex, 1);
  nextRows.splice(targetIndex, 0, moved);
  return nextRows;
}

